import { formatDistanceToNow } from 'date-fns';
import { createElement as rc, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Text } from 'lib_ui-primitives';

export default function TimeAgo({ date, ...props }) {
    const [timeAgo, setTimeAgo] = useState('');

    useEffect(() => {
        const update = () => {
            if (!date) return;
            const d = typeof date === 'string' ? new Date(date) : date;
            if (isNaN(d.getTime())) {
                setTimeAgo('');
                return;
            }
            setTimeAgo(formatDistanceToNow(d, { addSuffix: true }));
        };

        update();
        const interval = setInterval(update, 60000); // update every minute
        return () => clearInterval(interval);
    }, [date]);

    if (!timeAgo) return null;

    return rc(Text, { id: 'time-ago', testID: 'time-ago', 'data-testid': 'time-ago', children: timeAgo, ...props });
}

TimeAgo.propTypes = {
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
};
